import { NgModule } from '@angular/core'
import { MatDialogModule } from '@angular/material/dialog'
import { ChangePartyFormComponent } from './change-party-form.component'
import { ChangePartyFormService } from './change-party-form.service'
import { ChangePartyService } from './change-party.service'

@NgModule({
  providers: [ChangePartyFormService, ChangePartyService],
  imports: [
    MatDialogModule,
    ChangePartyFormComponent,
  ],
})
export class ChangePartyFormModule {}
